import { Breadcrumb, Button, Card, Col, Flex, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../../../../assets/icon/downloadIcon.svg"
import TableAntd from "components/elements/Table";
import EmployeeUnderLabourModal from "../reportModal/EmployeeUnderLabourModal";
import dayjs from "dayjs";
import styles from "../../styles/ReportStyles.module.css";

const EmployeeRegisterUnderLabourReport = ({
    initialValues,
    showReport,
    isDownloading = false,
    isModalOpen = false,
    departmentOptions = [],
    positionOptions = [],
    handleSearch = () => { },
    setIsModalOpen = () => { },
    showModal = () => { },
    reportEmpUnderLabour = [],
    pagination = {},
    onChange = () => { },
    isLoading = false,
    exportEmployeeUnderLabourReport = () => { }
}) => {
    const { t, i18n } = useTranslation();

    const columns = [
        {
            title: <div className="text-table">{t('name-surname')}</div>,
            dataIndex: "fullName",
            key: "fullName",
            align: "left",
            render: (_, record) => {
                return (record?.name ?
                    (i18n.language === "en" ? record?.nameEn + " " + record?.surNameEn : record?.name + " " + record?.surName) : "-"
                )
            },
            width: 180
        },
        {
            title: <div className="text-table">{t('gender')}</div>,
            dataIndex: "gender",
            key: "gender",
            align: "left",
            render: (_, record) => {
                return (record?.gender ?
                    (i18n.language === "en" ? record?.gender?.commonTypeNameEn : record?.gender?.commonTypeName) : "-"
                )
            },
            width: 80
        },
        {
            title: <div className="text-table">{t('birthday')}</div>,
            dataIndex: "dateOfBirth",
            key: "dateOfBirth",
            align: "left",
            render: (_, record) => {
                return (record?.dateOfBirth ?
                    (i18n.language === "en" ? dayjs(record?.dateOfBirth)?.format("DD/MM/YYYY") : dayjs(record?.dateOfBirth)?.format("DD/MM/BBBB")) : "-"
                )
            },
            width: 140
        },
        {
            title: <div className="text-table">{t('age')}</div>,
            dataIndex: "age",
            key: "age",
            align: "left",
            render: (_, record) => {
                return (record?.age ?
                    record?.age : "-"
                )
            },
            width: 80
        },
        {
            title: <div className="text-table">{t('report.address')}</div>,
            dataIndex: "address",
            key: "address",
            align: "left",
            render: (_, record) => {
                return (record?.address ?
                    (i18n.language === "en" ? `${record?.addressEn} ${record?.subDistrict?.subdistrictNameEn} ${record?.district?.districtNameEn} ${record?.province?.provinceNameEn} ${record?.subDistrict?.zipCode}`
                        : `${record?.address} ${record?.subDistrict?.subdistrictName} ${record?.district?.districtName} ${record?.province?.provinceName} ${record?.subDistrict?.zipCode}`) : "-"
                )
            },
            width: 250
        },
        {
            title: <div className="text-table">{t('report.id_card')}</div>,
            dataIndex: "idCard",
            key: "idCard",
            align: "left",
            render: (_, record) => {
                return (record?.identificationNo ?
                    record?.identificationNo : "-"
                )
            },
            width: 150
        },
        {
            title: <div className="text-table">{t('report.employment_date')}</div>,
            dataIndex: "employmentDate",
            key: "employmentDate",
            align: "left",
            render: (_, record) => {
                return (record?.employmentDate ?
                    (i18n.language === "en" ? dayjs(record?.employmentDate)?.format("DD/MM/YYYY") : dayjs(record?.employmentDate)?.format("DD/MM/BBBB")) : "-"
                )
            },
            width: 150
        },
        {
            title: <div className="text-table">{t('wage-rate')}</div>,
            dataIndex: "wageRate",
            key: "wageRate",
            children: [
                {
                    title: <div className="text-table">{t('report.perDay')}</div>,
                    dataIndex: 'perDay',
                    key: 'perDay',
                    render: (_, record) => {
                        return ((record?.salary && (record?.paymentType == "daily")) ?
                            (record?.salary) : ""
                        )
                    },
                    align: "right",
                    width: 100
                },
                {
                    title: <div className="text-table">{t('report.perMonth')}</div>,
                    dataIndex: 'perMonth',
                    key: 'perMonth',
                    render: (_, record) => {
                        return ((record?.salary && (record?.paymentType == "monthly")) ?
                            (record?.salary) : ""
                        )
                    },
                    align: "right",
                    width: 100
                },
            ]
        },
        {
            title: <div className="text-table">{t('report.other_benefit')}</div>,
            dataIndex: "otherBenefit",
            key: "otherBenefit",
            align: "left",
            width: 170
        },
        {
            title: <div className="text-table">{t('report.end_date_employment')}</div>,
            dataIndex: "endDateOfEmployment",
            key: "endDateOfEmployment",
            align: "left",
            render: (_, record) => {
                return (record?.dateExpiration ?
                    (i18n.language === "en" ? dayjs(record?.dateExpiration)?.format("DD/MM/YYYY") : dayjs(record?.dateExpiration)?.format("DD/MM/BBBB")) : "-"
                )
            },
            width: 150
        },
    ]

    const calculateScrollX = (columns) => {
        return columns.reduce((sum, column) => {
            if (column.children) {
                // สำหรับ grouped columns
                return sum + column.children.reduce((childSum, child) => childSum + (child.width || 0), 0);
            }
            return sum + (column.width || 0);
        }, 0);
    };

    const scrollX = calculateScrollX(columns);

    const scroll = {
        x: scrollX
        // ไม่ใส่ y
    };
    return (
        <>
            <EmployeeUnderLabourModal
                isDownloading={isDownloading}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                exportEmployeeUnderLabourReport={exportEmployeeUnderLabourReport}
            />
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("report.header"), href: "" },
                        { title: t("employee_history_group.header"), href: "" },
                        { title: t("employee_register_under_labour_report.header") }
                    ]} />
                    <h2>{t("employee_register_under_labour_report.header")}</h2>
                </Flex>

                <FormAntd
                    initialValues={{ ...initialValues }}
                    onFinish={handleSearch}
                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0",
                                    }}>
                                        <Flex vertical style={{ rowGap: "24px" }}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeId"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="searchTxt"
                                                        label={t("name-surname")}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="departmentList"
                                                        label={t('employee.label.department')}
                                                        options={departmentOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="positionList"
                                                        label={t('position.header')}
                                                        options={positionOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="month"
                                                        label={t('unit.month')}
                                                        allowClear
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                        picker="month"
                                                        dateFormat="MMMM / YYYY"
                                                        required
                                                    />
                                                </Col>
                                            </Row>


                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>

                                    {showReport && (
                                        <Space direction="vertical" size={16} >
                                            <Flex justify="end">
                                                <Button
                                                    type="default"
                                                    style={{ height: "40px", borderRadius: "8px" }}
                                                    onClick={showModal}
                                                >
                                                    <Flex gap={8}>
                                                        <DownloadIcon />
                                                        <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                    </Flex>
                                                </Button>
                                            </Flex>

                                            <Card style={{
                                                backgroundColor: "white",
                                                width: "100%",
                                                border: "1px solid #EAECF0",
                                            }}>
                                                <Space direction="vertical" size={8}>
                                                    <span style={{ fontSize: "14px", fontWeight: "bold" }}>{t('overtime_report.header')}</span>
                                                    <TableAntd
                                                        loading={isLoading}
                                                        onChange={onChange}
                                                        pagination={pagination}
                                                        columns={columns}
                                                        dataSource={reportEmpUnderLabour}
                                                        rowKey={(record) => record.id}
                                                        scroll={{
                                                            x: scrollX,
                                                            y: false
                                                        }}
                                                        size="small"
                                                        className={styles.tableCustom}
                                                    />
                                                </Space>
                                            </Card>
                                        </Space>
                                    )}
                                </>
                            );
                        }}
                    </FormItem>

                </FormAntd>
            </Space>
        </>
    )
}

export default EmployeeRegisterUnderLabourReport;